import parse from "html-react-parser";
import Button from "../../Elements/Button/Button.js";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import Authentication from "../Authentication/index.tsx";

import { useContent } from "contexts/contentContext/contentContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications/dist/ToastProvider.js";

const isCustomDomain = checkCurrDomainIsOrgDomain();

const RequestAccessMessage = ({ isEmbedOwnerOnly }) => {
  const { getTextByKey } = useContent();
  const { requestAccessFromOwner } = useMail();
  const { getUserData, isLoggedIn, logout } = useUser();
  const { setModal } = useModal();
  const { addToast } = useToasts();

  const userEmail = getUserData().UserName;

  const requestAccess = async () => {
    const response = await requestAccessFromOwner();
    if (response.status === "success") {
      // send notification success
      addToast(getTextByKey("request-access-success"), {
        appearance: "success",
      });
      return response;
    }

    // send error notification
    addToast(getTextByKey("request-access-fail"), {
      appearance: "error",
    });
    return response;
  };

  const switchAccounts = async () => {
    logout();
    setModal({
      modal: Authentication,
      modalSize: "full-modal",
      props: {
        type: "sign-up",
      },
    });
  };

  const loginModal = async () => {
    setModal({
      modal: Authentication,
      modalSize: "full-modal",
      props: {
        type: "sign-in",
      },
    });
  };

  return (
    <div className="mail-message-container request-access-container">
      <div className="title">
        {getTextByKey(
          isCustomDomain
            ? "request-access-title-custom-domain"
            : "request-access-title"
        )}
      </div>
      {isLoggedIn() ? (
        <>
          <div className="sub-title">
            {getTextByKey("request-access-sub-title")}
          </div>
          <div className="request-access-text">
            {parse(getTextByKey("request-access-text"))}
          </div>
          <div className="request-access-text-user">
            {getTextByKey("request-access-text-user")} {userEmail}
          </div>
          <div className="buttons-container">
            <Button blank medium onClick={() => switchAccounts()}>
              {getTextByKey("switch-accounts")}
            </Button>
            {!isEmbedOwnerOnly ? (
              <Button medium onClick={() => requestAccess()}>
                {getTextByKey("request-access")}
              </Button>
            ) : null}
          </div>
        </>
      ) : (
        <>
          <div className="sub-title">
            {getTextByKey("request-access-sub-title")}
          </div>
          <div className="request-access-text">
            {parse(getTextByKey("request-access-text"))}
          </div>
          <div className="buttons-container">
            <Button blank medium onClick={() => loginModal()}>
              {getTextByKey("login")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default RequestAccessMessage;
